export const NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS = {
	onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
	areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
	takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
	isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
	templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues',
} as const;

export const NthUserHomeOnboardingRevampKeys: readonly (
	| 'nth-user-home-onboarding-revamp:onboardingActionStates'
	| 'nth-user-home-onboarding-revamp:areAllActionsDismissed'
	| 'nth-user-home-onboarding-revamp:takeoverSeenAt'
	| 'nth-user-home-onboarding-revamp:isTemplateListDismissed'
	| 'nth-user-home-onboarding-revamp:templateUsageValues'
)[] = Object.values(NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS);
